<template>
  <div class="update__package_quantity">
    <!-- update quantity -->
    <vs-popup class="calendar-modal" id="update__package_qty" title="Update Quantity" button-accept="false" button-cancel="false" :style="{ 'z-index': zIndex }" :active.sync="isActive">
      <form>
        <div class="vx-row mb-4">
          <div class="vx-col mb-4 w-full">
            <vs-radio type="radio" v-model="form.transaction" name="Transaction Type" vs-value="addition">Add</vs-radio>
            <vs-radio type="radio" v-model="form.transaction" name="Transaction Type" vs-value="subtract" class="ml-3">Subtract </vs-radio>
            <span class="text-danger text-sm" v-show="errors.has('Transaction Type')">{{ errors.first('Transaction Type') }}</span>
          </div>
          <!-- quantity -->
          <div class="vx-col mb-4 w-full">
            <div class="flex">
              <div class="w-1/2 mr-2">
                <vs-input
                  icon-pack="feather"
                  :icon="form.transaction === 'subtract' ? 'icon-minus' : 'icon-plus'"
                  :value="form.quantity"
                  v-validate="'required|not_zero'"
                  type="number"
                  :step="[categories.FLOWER, categories.SHAKE].includes(updatePackageQty.categoryId) ? 0.001 : 1"
                  placeholder="Enter Quantity"
                  name="Quantity"
                  :min="0"
                  :max-decimal="3"
                  @input="quantityChangeHandler($event)"
                />
                <span class="text-danger text-sm" v-show="errors.has('Quantity')">{{ errors.first('Quantity') }}</span>
              </div>

              <!-- weight type -->
              <div class="w-1/2">
                <select-2
                  autocomplete
                  name="weight Type"
                  :value="form.weight_type"
                  @input="
                    (item) => {
                      form.weight_type = item && item.value
                    }
                  "
                  placeholder="Select Weight Type"
                  :options="weightTypeOptions"
                  v-validate="'required'"
                />

                <span class="text-danger text-sm" v-show="errors.has('weight Type')">{{ errors.first('weight Type') }}</span>
              </div>
            </div>
          </div>

          <!-- adjacement reason type -->
          <div class="vx-col mb-4 w-full">
            <label for=""></label>
            <select-2
              autocomplete
              class="w-full"
              :value="form.reason"
              @input="(item) => (form.reason = item && item.value)"
              name="Adjustment Reason"
              placeholder="Select Adjustment Reason"
              :options="adjustmentReasons"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Adjustment Reason')">{{ errors.first('Adjustment Reason') }}</span>
          </div>

          <!-- date -->
          <div class="vx-col w-full mb-4 relative">
            <date-picker
              :appendToBody="false"
              v-model="form.date"
              placeholder="MM-DD-YYYY"
              format="MM-DD-YYYY"
              valueType="format"
              class="w-full"
              label="Growth Date"
              name="Growth Date"
              v-validate="'required'"
            />
            <!-- <datepicker class="w-full" clear-button :format="dateFormat" v-model="form.date" placeholder="Select Adjustment Date" /> -->
          </div>

          <!-- adjustment note -->
          <div class="vx-col mb-4 w-full">
            <vs-input class="w-full" v-model="form.notes" type="textarea" name="Adjustment Note" placeholder="Select Adjustment Note" />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <div class="float-right">
              <vs-button class="mr-2" type="relief" @click="saveQuantity" :disabled="!validateForm || loading">Save</vs-button>
              <vs-button color="danger" @click="isActive = false" type="relief" class="text-left">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { adjustmentReasons } from '@/utils/enums'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { weightTypes } from '@/utils/weightType'
import { mapActions, mapMutations, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'UpdatePackageQuantity',

  components: {
    VuePerfectScrollbar,
    Select2,
    DatePicker
  },

  props: {
    isUpdatePackageQtyModalShow: Boolean,
    productId: Number,
    weightType: String,
    updatePackageQty: Object
  },

  data() {
    return {
      zIndex: 0,
      adjustmentReasons,

      loading: false,
      form: {
        notes: null,
        date: moment().format('MM-DD-YYYY'),
        reason: null,
        weight_type: null,
        quantity: null,
        transaction: 'addition'
      }
    }
  },

  created() {
    this.$validator.extend('not_zero', {
      getMessage: (field) => `${field} can't be zero.`,
      validate: (value) => value !== 0
    })
  },

  mounted() {
    // set modal zindex
    this.SET_MODAL_ZINDEX(true)

    this.form.weight_type = [this.categories.FLOWER, this.categories.SHAKE].includes(this.updatePackageQty.categoryId) ? this.weightType : 'unit'

    // set z index
    this.zIndex = this.modal.modalZIndex + this.modal.modalOpens + 1
  },

  computed: {
    ...mapState('product', { categories: 'categories' }),
    ...mapState(['modal']),

    isActive: {
      get() {
        return this.isUpdatePackageQtyModalShow
      },

      set(val) {
        if (!val) {
          // set modal zindex
          this.SET_MODAL_ZINDEX(false)
        }

        this.$emit('update:isUpdatePackageQtyModalShow', val)
      }
    },

    validateForm() {
      return !this.errors.any()
    },

    weightTypeOptions() {
      return [this.categories.FLOWER, this.categories.SHAKE].includes(this.updatePackageQty.categoryId) ? weightTypes.filter((x) => x.value !== 'unit') : weightTypes.filter((x) => x.value === 'unit')
    }
  },

  methods: {
    ...mapActions('product', ['quantityEdit']),
    ...mapMutations(['SET_MODAL_ZINDEX']),

    // save quantity
    async saveQuantity() {
      if (!(await this.$validator.validate())) {
        return false
      }
      this.loading = false

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: 'Are you sure you want to save this record?',
        acceptText: 'Yes, I am sure!',
        cancelText: 'No, cancel it!',
        accept: () => {
          this.updateQty()
        }
      })
    },

    // update quantity
    async updateQty() {
      this.loading = true

      this.$store
        .dispatch('product/quantityEdit', { id: this.productId, data: { ...this.form, date: moment(this.form.date).format('YYYY-MM-DD HH:mm'), quantity: Number(this.form.quantity) } })
        .then(({ message }) => {
          // clear the form
          const self = this
          Object.keys(this.form).forEach(function (key) {
            delete self.form[key]
          })

          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.$emit('done')
          this.isActive = false
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    // product quantity change handler
    quantityChangeHandler(e) {
      if ([this.categories.FLOWER, this.categories.SHAKE].includes(this.updatePackageQty.categoryId)) {
        this.form.quantity = e
      } else {
        this.form.quantity = Number(Math.round(e || 0))
      }
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#update__package_qty',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#update__package_qty > .con-vs-loading')
      }
    }
  }
}
</script>

<style>
.vdp-datepicker__calendar {
  width: 250px !important;
}
.calendar-modal .vs-popup--content {
  overflow: unset;
}
</style>